import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { Technician } from 'models/user';
import UpdateTechnicianForm from './update-technician-form.component';
import { useTranslation } from 'react-i18next';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';

type UpdateTechniciansDialogProps = {
    isDialogOpen: boolean;
    technician: Technician;
    onDialogCloseClick: () => void;
    onUpdateTechnicianClick: () => void;
};

const UpdateTechniciansDialog: FC<UpdateTechniciansDialogProps> = ({
    isDialogOpen,
    technician,
    onDialogCloseClick,
    onUpdateTechnicianClick,
}: UpdateTechniciansDialogProps) => {
    const { t: translate } = useTranslation(['users']);

    return (
        <DHDialog
            title={
                <Box>
                    <Box>{translate('users:UPDATE_TECHNICIAN')}</Box>
                    <Typography sx={{ float: 'right' }} color="gray" variant="caption">
                        {technician._id}
                    </Typography>
                </Box>
            }
            maxWidth="md"
            fullWidth
            open={isDialogOpen}
            onClose={onDialogCloseClick}
        >
            <UpdateTechnicianForm
                onUpdateTechnicianClick={onUpdateTechnicianClick}
                onDialogCloseClick={onDialogCloseClick}
                technician={technician}
            />
        </DHDialog>
    );
};

export default UpdateTechniciansDialog;
